/**
 * NutriQtyLock — candado de cantidad y botones «Comprar» (tienda 100% digital).
 * 1) Clamp: toda línea del carrito con qty > 1 se corrige a 1.
 * 2) Tarjetas (forms a /cart/add) cuyo producto ya está en el carrito: «En el carrito», apagadas.
 *    El botón de pago dinámico se esconde y en su lugar va «Ver carrito».
 * 3) (17-oct, Josué) UN SOLO VERBO «Comprar»: agrega al carrito y abre el aviso del carrito
 *    (con «Pagar pedido»). Antes «Comprar ahora» mandaba al checkout con TODO el carrito.
 *    buy(variantId) (alias buyNow, que es lo que llaman las secciones). Si ya está en el
 *    carrito, el botón dice «Ver carrito» y lleva al carrito. Botones: [data-gkh-buy],
 *    [data-dln-buy], .pdp-sticky__btn, [data-dpq-buy], [data-dps-buy] y [data-ebook-purchase]
 *    (antes solo subía al héroe).
 * 4) Tiempo real: se repinta al agregar/quitar (pubsub de Dawn, fetch a /cart/*, tarjetas nuevas,
 *    volver atrás).
 * 5) Sugeridos [data-gk-hide-in-cart]: se esconde lo que ya está en el carrito; máx. [data-gk-limit].
 * 6) (17-oct) /cart: tras cualquier cambio se repinta también el pie (#main-cart-footer, «Total
 *    estimado») y el ícono; Dawn solo repintaba la lista y el total quedaba viejo.
 * 7) (28-oct, Josué) Círculo de espera en TODOS los botones de compra (landing, barra fija,
 *    tarjetas, bloques del Inicio, packs): desde el clic hasta que aparece el aviso del carrito
 *    o se cambia de página. Clase .gk-busy (el texto queda invisible y gira un aro del mismo color).
 */
(function () {
  'use strict';
  if (window.NutriQtyLock) return;

  var routes = window.routes || {};
  var CART_URL = routes.cart_url || '/cart';
  var ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (routes.cart_change_url || '/cart/change') + '.js';
  var BUY_LABEL = 'Comprar';
  var IN_CART_LABEL = 'Ver carrito';
  var BUY_SELECTOR = '[data-gkh-buy],[data-dln-buy],[data-dpq-buy],[data-dps-buy],.pdp-sticky__btn';
  var BUSY_SELECTOR = BUY_SELECTOR + ',[data-ebook-purchase],form[action*="/cart/add"] [type="submit"]';
  var IS_CART_PAGE = /\/cart\/?$/.test(location.pathname);

  var state = { variants: {}, fetched: false, itemCount: 0 };
  var cartDirty = false; // en /cart: hubo un cambio y hay que volver a pintar el pie
  var leaving = false;   // se está yendo a otra página: dejar el círculo girando

  (function injectCss() {
    var s = document.createElement('style');
    s.textContent = '.nutri-in-cart .shopify-payment-button{display:none!important}' +
      '[data-gk-hide-in-cart] [data-gk-item][hidden],[data-gk-hide-in-cart][hidden]{display:none!important}' +
      '.gk-busy{position:relative!important;color:transparent!important;pointer-events:none!important;cursor:progress!important}' +
      '.gk-busy>*{visibility:hidden!important}' +
      '.gk-busy::after{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-9px 0 0 -9px;box-sizing:border-box;' +
      'border:2px solid var(--gk-spin,#1a253a);border-right-color:transparent;border-radius:50%;animation:gk-spin .7s linear infinite;visibility:visible}' +
      '@keyframes gk-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.gk-busy::after{animation-duration:1.6s}}' +
      '.nf-add-btn .loading__spinner{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  })();

  // ── Círculo de espera ──
  function setBusy(el) {
    if (!el || el.classList.contains('gk-busy')) return;
    var color = getComputedStyle(el).color;
    el.style.setProperty('--gk-spin', color);
    el.classList.add('gk-busy');
    el.setAttribute('aria-busy', 'true');
    clearTimeout(el._gkBusyT);
    el._gkBusyT = setTimeout(function () { clearBusy(el); }, 12000);
  }
  function clearBusy(el) {
    clearTimeout(el._gkBusyT);
    el.classList.remove('gk-busy');
    el.removeAttribute('aria-busy');
    el.style.removeProperty('--gk-spin');
  }
  function clearAllBusy() {
    if (leaving) return;
    document.querySelectorAll('.gk-busy').forEach(clearBusy);
  }
  function go(url) {
    leaving = true;
    window.location.href = url;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(BUSY_SELECTOR);
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('is-in-cart')) return;
    setBusy(b);
  }, true);

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.variants = {};
        (cart.items || []).forEach(function (it) {
          state.variants[it.variant_id] = it.quantity;
        });
        state.itemCount = cart.item_count || 0;
        state.fetched = true;
        return cart;
      });
  }

  function clampQuantities(cart) {
    var lines = [];
    (cart.items || []).forEach(function (it, i) {
      if (it.quantity > 1) lines.push(i + 1);
    });
    if (!lines.length) return Promise.resolve(false);
    // corregir secuencialmente (el índice de línea no cambia al ajustar cantidades)
    var chain = Promise.resolve();
    lines.forEach(function (line) {
      chain = chain.then(function () {
        return fetch(CHANGE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 1 })
        });
      });
    });
    return chain.then(function () { return true; });
  }

  function syncBuyNow(form, inCart) {
    var wrap = form.closest('.product-form') || form.parentElement;
    if (!wrap) return;
    var pay = wrap.querySelector('.shopify-payment-button');
    if (!pay) return;
    var link = wrap.querySelector('.nutri-go-checkout');
    wrap.classList.toggle('nutri-in-cart', inCart);
    if (inCart) {
      if (!link) {
        link = document.createElement('a');
        link.href = CART_URL;
        link.className = 'nutri-go-checkout shopify-payment-button__button shopify-payment-button__button--unbranded';
        link.textContent = IN_CART_LABEL;
        link.style.display = 'flex';
        link.style.alignItems = 'center';
        link.style.justifyContent = 'center';
        link.style.textDecoration = 'none';
        pay.parentNode.insertBefore(link, pay.nextSibling);
      }
    } else if (link) {
      link.remove();
    }
  }

  function variantOf(form) {
    var idInput = form && form.querySelector('input[name="id"], select[name="id"]');
    return idInput ? Number(idInput.value) : 0;
  }

  function markAddButtons() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var btn = form.querySelector('[type="submit"]');
      var id = variantOf(form);
      if (!id || !btn) return;
      var inCart = !!state.variants[id];
      var label = btn.querySelector('span') || btn;
      if (inCart) {
        if (!btn.dataset.nutriLockedText) btn.dataset.nutriLockedText = label.textContent;
        label.textContent = 'En el carrito';
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-in-cart');
        clearBusy(btn);
      } else if (btn.dataset.nutriLockedText) {
        label.textContent = btn.dataset.nutriLockedText;
        delete btn.dataset.nutriLockedText;
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-in-cart');
        btn.classList.remove('loading');
        var spin = btn.querySelector('.loading__spinner');
        if (spin) spin.classList.add('hidden');
      }
      syncBuyNow(form, inCart);
    });
  }

  // ── Botones «Comprar» de las landings ──
  function pageVariant() {
    var b = document.querySelector('[data-gkh-buy][data-variant-id], .pdp-sticky__btn[data-variant-id]');
    return b ? Number(b.dataset.variantId) : 0;
  }

  function labelEl(btn) {
    return btn.querySelector('.pdp-sticky__btn-label') || btn;
  }

  function setLabel(btn, text) {
    var el = labelEl(btn);
    if (el.textContent.trim() !== text) el.textContent = text;
  }

  function markBuyButtons() {
    document.querySelectorAll(BUY_SELECTOR).forEach(function (btn) {
      var id = Number(btn.dataset.variantId);
      if (!id) return;
      // las secciones lo apagan al hacer clic; aquí se vuelve a encender
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
      setLabel(btn, state.variants[id] ? IN_CART_LABEL : BUY_LABEL);
    });
    var pv = pageVariant();
    document.querySelectorAll('[data-ebook-purchase]').forEach(function (a) {
      if (a.matches(BUY_SELECTOR)) return;
      var id = Number(a.dataset.variantId) || pv;
      a.textContent = id && state.variants[id] ? IN_CART_LABEL : BUY_LABEL;
    });
  }

  // Sugeridos: esconder lo que ya está en el carrito y respetar el máximo de tarjetas.
  function filterRecommendations() {
    document.querySelectorAll('[data-gk-hide-in-cart]').forEach(function (box) {
      var limit = parseInt(box.getAttribute('data-gk-limit'), 10) || 999;
      var shown = 0;
      var items = box.querySelectorAll('[data-gk-item]');
      // Sin tarjetas todavía (recomendaciones que cargan al hacer scroll): no tocar la caja,
      // si se escondiera nunca entraría en pantalla y nunca cargaría.
      if (!items.length) { box.removeAttribute('hidden'); return; }
      items.forEach(function (item) {
        var id = variantOf(item.querySelector('form[action*="/cart/add"]'));
        var hide = (id && state.variants[id]) || shown >= limit;
        if (hide) {
          item.setAttribute('hidden', '');
        } else {
          item.removeAttribute('hidden');
          shown++;
        }
      });
      if (shown === 0) box.setAttribute('hidden', '');
      else box.removeAttribute('hidden');
    });
  }

  function paint() {
    markAddButtons();
    markBuyButtons();
    filterRecommendations();
  }

  // ── /cart: volver a pintar el pie (Total estimado) y el contador ──
  function rerenderCartFooter() {
    var footer = document.getElementById('main-cart-footer');
    var ids = [];
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (!ids.length) return Promise.resolve();
    var url = location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    // ojo: sin «Accept: application/json» (con ese encabezado /cart devuelve el carrito en JSON
    // y no las secciones)
    return fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
        if (footer && sections[footer.dataset.id]) {
          var doc = parse(sections[footer.dataset.id]);
          var src = doc.querySelector('.js-contents');
          var dst = footer.querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        }
        var empty = state.itemCount === 0;
        if (footer) footer.classList.toggle('is-empty', empty);
        var items = document.querySelector('cart-items');
        if (items) items.classList.toggle('is-empty', empty);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () { /* si falla, al recargar queda bien */ });
  }

  function refresh() {
    var wantFooter = cartDirty;
    cartDirty = false;
    return fetchCart().then(function (cart) {
      return clampQuantities(cart).then(function (changed) {
        paint();
        // en la página del carrito, recargar una vez para reflejar la corrección
        if (changed && IS_CART_PAGE && !sessionStorage.getItem('nutri_qty_reloaded')) {
          sessionStorage.setItem('nutri_qty_reloaded', '1');
          location.reload();
          return;
        } else if (!changed) {
          sessionStorage.removeItem('nutri_qty_reloaded');
        }
        if (wantFooter && IS_CART_PAGE) return rerenderCartFooter();
      });
    }).catch(function () { /* red caída: no bloquear la página */ });
  }

  // ── Comprar: agrega y abre el aviso del carrito ──
  function publishCartUpdate(variantId, data) {
    try {
      var EVENTS = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
      if (typeof publish === 'function' && EVENTS && EVENTS.cartUpdate) {
        publish(EVENTS.cartUpdate, { source: 'nutri-buy', productVariantId: variantId, cartData: data });
      }
    } catch (e) { /* sin pubsub */ }
  }

  var busy = false;
  function buy(variantId) {
    variantId = Number(variantId);
    if (!variantId || busy) return Promise.resolve();
    busy = true;
    var notif = document.querySelector('cart-notification');
    var canNotify = notif && typeof notif.renderContents === 'function' && typeof notif.getSectionsToRender === 'function';
    return fetchCart().then(function () {
      if (state.variants[variantId]) { go(CART_URL); return; }
      var body = { id: variantId, quantity: 1 };
      if (canNotify) {
        body.sections = notif.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      return fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (data) {
        if (!canNotify || !data || !data.sections) { go(CART_URL); return; }
        state.variants[variantId] = 1;
        paint();
        try { notif.renderContents(data); } catch (e) { go(CART_URL); return; }
        publishCartUpdate(variantId, data);
      });
    }).catch(function () {
      go(CART_URL);
    }).then(function () {
      busy = false;
      if (state.fetched) paint();
      clearAllBusy();
    });
  }

  window.NutriQtyLock = {
    refresh: refresh,
    buy: buy,
    buyNow: buy, // las secciones llaman buyNow: ahora también agrega y abre el aviso
    inCart: function (id) { return !!state.variants[Number(id)]; }
  };

  // Enlaces «Comprar» de «Una receta por dentro» ([data-ebook-purchase]): antes solo subían al héroe.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ebook-purchase]');
    if (!a || a.matches(BUY_SELECTOR)) return;
    var id = Number(a.dataset.variantId) || pageVariant();
    if (!id) return;
    e.preventDefault();
    e.stopPropagation(); // que no lo tome el salto al héroe (#comprar)
    buy(id);
  }, true);

  var refreshTimer = null;
  function refreshSoon(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay || 150);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();

  // Cambios de carrito publicados por Dawn (pubsub): agregar desde una tarjeta, quitar en el carrito, etc.
  try {
    var EVENTS = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (typeof subscribe === 'function' && EVENTS && EVENTS.cartUpdate) {
      subscribe(EVENTS.cartUpdate, function () { cartDirty = true; refreshSoon(150); setTimeout(clearAllBusy, 250); });
    }
  } catch (e) { /* sin pubsub: quedan los otros avisos */ }
  document.addEventListener('cart:updated', function () { cartDirty = true; refreshSoon(150); setTimeout(clearAllBusy, 250); });

  // Red de seguridad: cualquier llamada a /cart/add|change|update|clear hecha con fetch
  // (aunque no publique evento) dispara una revisión del estado y apaga el círculo de espera.
  if (window.fetch && !window.fetch.__nutriWrapped) {
    var origFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { cartDirty = true; refreshSoon(250); setTimeout(clearAllBusy, 450); },
               function () { setTimeout(clearAllBusy, 100); });
      }
      return p;
    };
    wrapped.__nutriWrapped = true;
    window.fetch = wrapped;
  }

  // Tarjetas que aparecen después (recomendaciones que cargan tarde, secciones re-pintadas):
  // se pintan con el estado ya conocido, sin volver a pedir el carrito.
  if ('MutationObserver' in window) {
    var paintTimer = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('form[action*="/cart/add"], [data-gk-hide-in-cart]') || n.querySelector('form[action*="/cart/add"], [data-gk-hide-in-cart]'))) {
            clearTimeout(paintTimer);
            paintTimer = setTimeout(function () { if (state.fetched) paint(); }, 60);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Volver atrás con el navegador (página servida desde caché): el carrito pudo cambiar.
  window.addEventListener('pageshow', function (e) { leaving = false; clearAllBusy(); if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshSoon(50); });
})();